import { ModalProvider as TootzModalProvider } from '@/shared/contexts'

export const ModalProvider = ({ children }) => {
  return <TootzModalProvider>{children}</TootzModalProvider>
}
